export const APP_ID = import.meta.env.VITE_MONGO_APP_ID;
export const BASE_API_URL = import.meta.env.VITE_API_URL;

export const endpointsUrl = import.meta.env.VITE_MONGO_API_URL;
